import { SETTINGS_TABS } from "../constants/settingsTabs";
import { useAuthStore } from "../../../store/authStore";

export default function SettingsTabs({ activeTab, onChange }) {
  const user = useAuthStore((state) => state.user);
  const userRole = user?.role;

  const filteredTabs = SETTINGS_TABS.filter((tab) => {
    if (!tab.roles) return true;
    return tab.roles.includes(userRole);
  });

  return (
    <div className="flex overflow-x-auto no-scrollbar scroll-smooth shrink-0">
      {filteredTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`px-5 py-4 text-[13px] sm:text-sm font-medium border-b-2 transition-all whitespace-nowrap shrink-0 ${
            activeTab === tab.id
              ? "border-brand-blue text-brand-blue"
              : "border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-50/50"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
